export const aciSynchronizeArrowClock = {
    iconName: 'synchronize-arrow-clock',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M13.333 20.333a8.667 8.667 0 10-8.666-8.666v.666',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M2 9.664l2.667 2.667 2.666-2.667M12.667 6.33v6h4.666',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
